import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import { HashLink } from 'react-router-hash-link';

class Intro extends Component {

    gtag_report_conversion = (event, url = null) => {
        if (typeof window.gtag !== "function") {
            console.error("Google Ads is not loaded properly.");
            return;
        }

        window.gtag('event', 'conversion', {
            'send_to': 'AW-16832649503/oq0QCPbF0ZYaEJ-yt9o-'
        });

        console.log("Conversion event sent:", event.target);

        if (url) {
            setTimeout(() => {
                window.location.href = url;
            }, 500);
        }
    };


    render() {
        return (
            <section className="pt-100 center-about bg-grey">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="section-heading text-center">
                                <span>Step into the Future of Control</span>
                                <h2>Master Adaptive Systems with Neural Networks</h2>
                                <HashLink to="#contact">Got Questions About Neural Networks?​ <strong className="text-color" onClick={(event) => this.gtag_report_conversion(event)}> Get Your Free Guidebook to Learn More!</strong> </HashLink>
                            </div>
                        </div>
                    </div>
                </div>
                {/*
                <section className="cta-2 clients ">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-2 col-sm-6 ">
                                <div className="client-logo">
                                    <img src="assets/images/clients/logo1.png" alt="" className="img-fluid"/>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-6">
                                <div className="client-logo">
                                    <img src="assets/images/clients/logo2.png" alt="" className="img-fluid"/>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-6">
                                <div className="client-logo">
                                    <img src="assets/images/clients/logo3.png" alt="" className="img-fluid"/>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-6">
                                <div className="client-logo">
                                    <img src="assets/images/clients/logo4.png" alt="" className="img-fluid"/>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-6">
                                <div className="client-logo">
                                    <img src="assets/images/clients/logo5.png" alt="" className="img-fluid"/>
                                </div>
                            </div>
                            <div className="col-lg-2 col-sm-6">
                                <div className="client-logo">
                                    <img src="assets/images/clients/logo6.png" alt="" className="img-fluid"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}
            </section>
        );
    }
}

export default Intro;
